<template lang="pug">
	.widgets-area.segment.packages-selection-info
		.widgets-col
			.flex-col.space-large.widget
				.flex-col.space
					.font-small.upper.grey {{$tCaption('Budget')}}
					DxNumberBox(:value.sync="data.packageBudget")
				.flex-col.space
					.font-small.upper.grey {{$tCaption('Daypart')}}
					.flex-row.justify
						.daypart.clickable.flex-1.flex-row(v-for="daypart in dayparts", @click="toggleSelectedIdInArray(daypart.id, data.packageDayparts)", :class="{ selected: data.packageDayparts && data.packageDayparts.indexOf(daypart.id) > -1 }")
							.flex-col.center.align-center.icon-holder
								.icon(:class="[daypart.position]")
									i.fas(:class="[daypart.icon]", :style="{ fontSize: `${daypart.size}px` }")
							.flex-col.flex-1.data
								.start-time {{daypart.time}}
								.name {{daypart.name}}
				.flex-col.space
					.font-small.upper.grey {{$tCaption('Spot length')}}
					DxNumberBox(:value.sync="data.packageSpotLength", format="#0 seconds")
				PackagesSelectionStations(:data="data")
</template>

<script>
	import Data from 'app-core/Data';
	import PackagesSelectionStations from './PackagesSelectionStations.vue';
	import { DxNumberBox } from 'devextreme-vue/number-box';

	export default {
		translationCategory: 'proposal.PackagesSelectionInfo',
		name: 'packages-selection-info',
		components: {DxNumberBox, PackagesSelectionStations},
		mixins: [Data.mixin],
		props: ['data'],
		data() {
			return {
				dayparts: [
					{ id: 'mo', name: () => this.$tCaption('Morning'), time: '6:00 AM', icon: 'fa-sun', position: 'bottom', size: 60 },
					{ id: 'md', name: () => this.$tCaption('Midday'), time: '10:00 PM', icon: 'fa-sun', size: 60 },
					{ id: 'af', name: () => this.$tCaption('Afternoon'), time: '3:00 PM', icon: 'fa-sun', size: 60,  position: 'top', },
					{ id: 'ev', name: () => this.$tCaption('Evenings'), time: '7:00 PM', icon: 'fa-moon', size: 30 },
					{ id: 'on', name: () => this.$tCaption('Overnight'), time: '0:00 AM', icon: 'fa-moon', size: 60 }
				]
			};
		}
	};
</script>
<style lang='scss'>
	.packages-selection-info {
		@import "main/themes/generated/variables.base.scss";

		.daypart {
			background: $base-bg;
			border-bottom: 3px solid #f0f0f0;
			margin: 1px;
			transition: 0.3s;
			z-index: 0;

			> .data {
				padding: 10px;
			}

			.icon-holder {
				position: relative;
				width: 80px;
				height: 100%;
				overflow: hidden;

				> .icon {
					position: absolute;
					transition: 1.3s;
					transform: scale(0.75);


					&.bottom {
						bottom: -20px;
					}

					&.top {
						top: -20px;
					}
				}
			}

			.fa-sun {
				color: #ffe579;
			}

			.fa-moon {
				color: #1976bd;
			}

			&:hover {
				transform: scale(1.1);
				z-index: 1;
				border-bottom: 3px solid $base-accent;
				background: #f8f8f8;

				.icon-holder {
					> .icon {
						transform: scale(1) rotate(-120deg);
					}
				}
			}

			&.selected {
				background: #f8f8f8;
				border-bottom: 3px solid $base-accent;
			}
		}
	}
</style>
